import dayjs from 'dayjs';

export function parseXLSXData(rawData) {
  const parsedData = rawData.map((item) => ({
    id: item.A,
    shop: item.P,
    order: `${item.D} ${item.G}`,
    number: item.A,
    sendDate: dayjs(item.K, 'DD.MM.YYYY'),
    weight: item.H || 0,
    quantity: item.T || null,
    orderNumber: item.Q,
    invoiceNumber: item.R,
    cim: item.J,
    note: item.S,
    fcrNumber: item.U,
    fcrRecipient: item.V,
    fcrMarks: item.W,
    fcrRemarks: item.X,
    fcrInstructions: item.Y,
  }));

  const tableData = parsedData.map((item, index) => ({
    id: item.id,
    key: item.id,
    fieldId: index,
    number: item.number,
    sendDate: item.sendDate,
    quantity: item.quantity,
    weight: item.weight,
    orderNumber: item.orderNumber,
    invoiceNumber: item.invoiceNumber,
    cim: item.cim,
    note: item.note,
    fcrNumber: item.fcrNumber,
    fcrRecipient: item.fcrRecipient,
    fcrMarks: item.fcrMarks,
    fcrRemarks: item.fcrRemarks,
    fcrInstructions: item.fcrInstructions,
  }));
  const tableLabelsData = parsedData.map((item) => ({ shop: item.shop, order: item.order }));

  return { parsedData, tableData, tableLabelsData };
}
